import type { ReactNode } from 'react';

import type { Research } from '@/lib/crm/record/research/useResearch';

import type { MeetingPrepCompany } from '../utils/meetingPrepTypes';
import { MeetingPrepAccordionSection } from './meeting-prep-accordion-section';
import { MeetingPrepCompanyCard } from './meeting-prep-company-card';

interface MeetingPrepCompanyIntelSectionProps {
  companies: MeetingPrepCompany[];
  defaultExpanded: boolean;
  metadata?: string;
  badges?: ReactNode;
  researchById: Map<string, Research>;
}

export function MeetingPrepCompanyIntelSection({
  companies,
  defaultExpanded,
  metadata,
  badges,
  researchById,
}: MeetingPrepCompanyIntelSectionProps) {
  return (
    <MeetingPrepAccordionSection
      title='Company research'
      sectionId='company-intel'
      defaultExpanded={defaultExpanded}
      metadata={metadata}
      badges={badges}
    >
      <div>
        {companies.map(company => (
          <MeetingPrepCompanyCard
            key={company.entity_id}
            company={company}
            research={researchById.get(company.research_entity_id ?? '')}
          />
        ))}
      </div>
    </MeetingPrepAccordionSection>
  );
}
